import * as Yup from 'yup';

export const editBuyerSettingsSchema = () => {
  return Yup.object().shape({
    display_currency: Yup.string()
      .required('Currency is required')
      .max(3, 'Currency code must have maximum 3 characters'),
  });
};
